import React from 'react'
import Dropdown from '@components/ui/formElements/Dropdown'
import styles from '../styles.module.scss'
import { SetSelectionArgs } from '@components/ui/formElements/Dropdown/List'

type SizeChartDropDownProps = {
  collection: Record<string, string>
  selectedProduct: string
  setSelectedProduct: (product: string) => void
  list: string[]
}

const SizeChartDropDown = ({
  collection,
  selectedProduct,
  setSelectedProduct,
  list
}: SizeChartDropDownProps) => {
  if (!selectedProduct) return null

  const handleChange = (e: SetSelectionArgs) => {
    if (typeof e.product === 'string') {
      setSelectedProduct(e.product)
    }
  }

  const listSelection = Object.keys(collection)
    .filter(item => list.indexOf(item) > -1)
    .map(value => ({
      value,
      label: collection[value] || value
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

  return (
    <Dropdown
      defaultValue={selectedProduct}
      id="product"
      classes={`${styles.sizeChart__productsDropdown} dropdown--narrow`}
      list={listSelection}
      selection={selectedProduct}
      setSelection={handleChange}
    />
  )
}

export default SizeChartDropDown
